(function() {
    var alertId = "TopAlert";
    var storageKey = "alertClosed";
    var expirationDays = 7;

    function isAlertExpired() {
        var savedData = localStorage.getItem(storageKey);
        if (!savedData) return false;
        var parsedData = JSON.parse(savedData);
        return Date.now() > parsedData.timestamp;
    }

    function closeAlert() {
        var expirationTimestamp = Date.now() + expirationDays * 24 * 60 * 60 * 1000;
        localStorage.setItem(storageKey, JSON.stringify({
            timestamp: expirationTimestamp
        }));
        document.getElementById(alertId).classList.add("d-none");
    }

    document.addEventListener("DOMContentLoaded", function() {
        if (isAlertExpired()) {
            localStorage.removeItem(storageKey);
        } else if (localStorage.getItem(storageKey)) {
            document.getElementById(alertId).classList.add("d-none");
        }

        document.getElementById("closeAlert").addEventListener("click", closeAlert);
    });
})();